import moment from 'moment';
import { useEffect } from 'react';
import { setDefaultLocale } from 'react-datepicker';
import { useDispatch, useSelector } from 'react-redux';
import { setLocale } from '~/ducks/translations/reducer';
import { AppState } from '~/reducers';
import getDefaultLocale from '~/utils/get-default-locale/get-default-locale';
import mapBrowserLocaleToFleetLocale from '~/utils/map-browser-locale-to-fleet-locale/map-browser-locale-to-fleet-locale';
import intl from '~/utils/intl/intl-proxy';

const useBrowserLocale = () => {
  const dispatch = useDispatch();
  const locale = useSelector((state: AppState) => state.translation.locale);
  useEffect(() => {
    const navigatorLocale = mapBrowserLocaleToFleetLocale(navigator.language) ?? getDefaultLocale();
    dispatch(setLocale(navigatorLocale));
    moment.locale(navigatorLocale);
    setDefaultLocale(navigatorLocale);
    intl.updateIntl({}, navigatorLocale);
  }, [dispatch]);

  return { locale };
};
export { useBrowserLocale };
